export const TYPE_KEY = Symbol('resourceType');

export function typeAs(type) {
  return item => {
    item[TYPE_KEY] = type;
    return item;
  };
}
export const handlers = new Map();

export function updateHandler(el, binding) {
  el.removeEventListener('input', handlers.get(el));

  const handler = () => {
    const value = el.value.replace(/\D/g, '').slice(0, binding.value);
    if (value !== el.value) {
      el.value = value;
      el.dispatchEvent(new Event('input'));
    }
  };
  handler();
  handlers.set(el, handler);

  el.addEventListener('input', handler);
}
